/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';
import { LOCAL_STORAGE } from '../../utils/constants'

const PurchaseOrderBranchDropdown = ({
    field: { name, value },
    form: { setFieldValue },
    branchData,
    getBranchSelected,
    vendorId,
    vendorBranchCode,
    setVendorDetails,
    setBranchData,
    vendorStateId,
    ...props
}) => {

    const [vendorData, setVendorData] = useState([])

    useEffect(() => {
        if (vendorId) {

            let token = LOCAL_STORAGE.userToken
            let userId = LOCAL_STORAGE.userId
            let customerNo = LOCAL_STORAGE.customerNo

            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vendorDetails/${vendorId}?customerNumber=${customerNo}&userId=${userId}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((response => {
                    setVendorDetails(response.data.resultSet)
                    setVendorData(response.data.resultSet)
                    setBranchData(response.data.resultSet.branches)
                    if(response.data.resultSet.branches.length > 0){
                        setFieldValue(id,response.data.resultSet.branches[0]?.vendorBranchStateId)
                    }
                    getBranchSelected(vendorBranchCode, response.data.resultSet)
                }))
                .catch((error => {
                    console.log(error)
                }))
        }
    }, [])

    let options = []
    if (branchData && branchData.length > 0) {
        if (branchData && branchData.length == 1) {
            props?.setVendorBranchCode && props?.setVendorBranchCode(branchData[0]?.vendorBranchCode)
            vendorStateId && setFieldValue(id,response.data.resultSet.branches[0]?.vendorBranchStateId)
        }
        branchData.map((object, index) => {
            let temp = {}
            if (object?.vendorBranchCode && object?.vendorBranchName && object?.vendorBranchCode) {
                temp.key = object?.vendorBranchCode
                temp.text = object?.vendorBranchName
                temp.value = object?.vendorBranchCode
                options.push(temp)
            }
        })
        if (!value) {
            const defaultSelect = branchData.find(({ vendorBranchCode }) => vendorBranchCode != null)
            if (defaultSelect?.vendorBranchCode) {
                setFieldValue(name, defaultSelect?.vendorBranchCode);
            }
        }

    }

    const handleOnChange = (e, data) => {
        setFieldValue(name, data?.value);
        getBranchSelected(data.value, vendorData);
        const selectedObj = branchData.find(({ vendorBranchCode }) => vendorBranchCode == data.value)
        if (selectedObj?.gstChargeMechanism == 'RCM') {
            setFieldValue('chargeMechanismRCM', true);
        } else {
            setFieldValue('chargeMechanismRCM', false);
        }
        props?.setVendorBranchCode && props?.setVendorBranchCode(data.value)
    }

    useEffect(() => {
        if (value && branchData) {
            const selectedObj = branchData.find(({ vendorBranchCode }) => vendorBranchCode == value)
            if (selectedObj?.gstChargeMechanism == 'RCM') {
                setFieldValue('chargeMechanismRCM', true);
            } else {
                setFieldValue('chargeMechanismRCM', false);
            }
        }
    }, [value, branchData])
    return (
        <Dropdown
            search
            placeholder='Vendor Branch'
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            value={value || branchData[0]?.vendorBranchCode}
            {...props}
            fluid
        />
    )
}


export default PurchaseOrderBranchDropdown